import React, { useEffect, useState } from "react";
import { Box, Typography, Divider } from "@mui/joy";
import { MapPin, Clock, Video } from "lucide-react";
import { useProject } from "../../../../hooks/query";
import moment from "moment";

export default function UpcomingEvents() {
    const projectHook = useProject();
    const listProjectSvc = projectHook.useList();
    const [events, setEvents] = useState<any[]>([]);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const projects = await listProjectSvc.mutateAsync();
                if (!projects) return;

                const upcoming = projects
                    .filter((p: any) => p.Status === "IN-PROGRESS" || p.Status === "NOT-STARTED")
                    .filter((p: any) => p.EstimatedEndDate || p.InspectionDate)
                    .map((p: any) => ({
                        title: p.Name ? p.Name : (p.Client?.FirstName ? `Project - ${p.Client?.FirstName}` : "Site Inspection"),
                        time: p.InspectionDate ? moment(p.InspectionDate).format("hh:mm A") : "10:00 AM",
                        date: p.InspectionDate ? moment(p.InspectionDate).format("MMM DD") : moment(p.EstimatedEndDate).format("MMM DD"),
                        type: p.InspectionDate ? "Inspection" : "Deadline",
                        color: p.InspectionDate ? "#10b981" : "#eab308", // Tailored for dark/light contrast
                        bgColor: p.InspectionDate ? "rgba(16, 185, 129, 0.15)" : "rgba(234, 179, 8, 0.15)",
                        location: p.PropertyCity || "TBD",
                    }))
                    .sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime())
                    .slice(0, 3); // Take top 3

                setEvents(upcoming.length > 0 ? upcoming : [
                    { title: "Site Inspection - Smith Res", time: "09:00 AM", date: "Today", type: "Inspection", color: "#0f764a", bgColor: "rgba(15, 118, 74, 0.1)", location: "Denver" },
                    { title: "Material Delivery", time: "11:00 AM", date: "Today", type: "Logistics", color: "#ca8a04", bgColor: "rgba(202, 138, 4, 0.1)", location: "Boulder Ave" },
                    { title: "Client Update Meeting", time: "02:30 PM", date: "Tomorrow", type: "Meeting", color: "#d946ef", bgColor: "rgba(217, 70, 239, 0.1)", location: "Zoom" },
                ]);
            } catch (e) {
                console.error("Failed to fetch upcoming events", e);
            }
        };

        fetchEvents();
    }, []);

    return (
        <Box p={3} sx={{ bgcolor: "background.surface", borderRadius: "xl", mt: 0, border: "none", boxShadow: "sm" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography level="title-lg" sx={{ fontWeight: 800 }}>Schedule</Typography>
                <Typography level="body-sm" color="primary" sx={{ cursor: "pointer", fontWeight: 600 }}>See All</Typography>
            </Box>

            <Box display="flex" flexDirection="column" gap={3}>
                {events.map((event, idx) => (
                    <Box key={idx} display="flex" gap={2}>
                        <Box display="flex" flexDirection="column" alignItems="center" gap={0.5} width={60}>
                            <Typography level="body-sm" sx={{ fontWeight: 700, color: "text.primary" }}>{event.time.split(' ')[0]}</Typography>
                            <Typography level="body-xs" sx={{ fontWeight: 600, color: "text.tertiary" }}>{event.date}</Typography>
                        </Box>
                        
                        <Box 
                            flex={1} 
                            sx={{ 
                                p: 2, 
                                borderRadius: "xl", 
                                border: `1px solid ${event.color}40`,
                                borderLeft: `4px solid ${event.color}`,
                                bgcolor: event.bgColor,
                                boxShadow: "none"
                            }}
                        >
                            <Box display="flex" justifyContent="space-between" mb={1}>
                                <Typography level="title-sm" sx={{ fontWeight: 700, color: event.color }}>{event.title}</Typography>
                            </Box>
                            <Box display="flex" gap={2} alignItems="center">
                                <Typography level="body-xs" sx={{ display: "flex", alignItems: "center", gap: 0.5, fontWeight: 600, color: event.color, opacity: 0.8 }}>
                                    {event.type === "Meeting" ? <Video size={12} /> : event.type === "Inspection" ? <MapPin size={12} /> : <Clock size={12} />}
                                    {event.location}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
